import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WikiRoutingModule } from './wiki-routing.module';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';

import { SharedModule } from 'app/shared/shared.module';

import { WikiComponent } from './wiki.component';
import { EditorComponent } from './editor/editor.component';
import { ReorderContainerComponent } from './reorder-container/reorder-container.component';
import { SearchResultComponent } from './search-result/search-result.component';
import { EditorContainerComponent } from './editor-container/editor-container.component';
import { SideNavTreeComponent } from './side-nav-tree/side-nav-tree.component';

@NgModule({
    declarations: [
        WikiComponent,
        EditorComponent,
        ReorderContainerComponent,
        SearchResultComponent,
        SideNavTreeComponent,
        EditorContainerComponent,
    ],
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        CKEditorModule,
        DragDropModule,
        RouterModule,
        WikiRoutingModule
    ],
    exports: [
        WikiComponent
    ]
})
export class WikiModule { }
